import {Component, isDevMode, OnInit} from '@angular/core';
import {FormBuilder, FormControl, Validators} from "@angular/forms";

import {NewNavigationService} from "@shared/services/new-navigation.service";

import { WebAccessService } from '@commons/services/web.access/web-access.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styles: []
})
export class ResetPasswordComponent implements OnInit {

  isLoading = false;

  emailCtrl = new FormControl('', [Validators.required, Validators.email]);

  form = this.formBuilder.group({
    email: this.emailCtrl
  });

  constructor(private formBuilder: FormBuilder,
              private navigationService: NewNavigationService,
              private webAccessService: WebAccessService) {
  }

  ngOnInit(): void {
  }

  onReset() {
    this.isLoading = true;

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.isLoading = false;
      return;
    }

    this.resetPasswordForUser();
  }

  private resetPasswordForUser() {
    const email = this.emailCtrl.value!;

    this.webAccessService.resetPassword(email).subscribe({
      next: () => this.navigationService.toResetPasswordConfirmation(email),
      error: () => this.navigationService.toResetPasswordConfirmation(email) //ze względów bezpieczeństwa zawsze udajemy że reset się powiódł
    });
  }

}
